<div class="form-validation-errors" *ngIf="validationErrors">
    <small *ngIf="validationErrors.required" class="invalid-feedback">
        {{ 'GENERAL.REQUIRED_FIELD' | translate }}
    </small>
    <small *ngIf="validationErrors.minLength" class="invalid-feedback">
        {{ 'GENERAL.MIN_LENGTH' | translate }}
    </small>
    <small *ngIf="validationErrors.maxLength" class="invalid-feedback">
        {{ 'GENERAL.MAX_LENGTH' | translate }}
    </small>
</div>
